<template>

  <header class="topbar">

    <nav class="navbar top-navbar navbar-expand-md navbar-dark">

      <div class="navbar-header">

        <button type="button" class="nav-toggler waves-effect waves-light d-block d-md-none" :aria-label="$t('header.open_menu')">
          <i class="fas-menu fas-close"></i>
        </button>

        <router-link class="navbar-brand" to="/dashboard">
          <img src="/logo-banner.png" alt="SocialLabs" class="brand-logo" />
        </router-link>

      </div>

      <div class="navbar-collapse collapse" id="navbarSupportedContent">

        <ul class="navbar-nav float-left mr-auto">

          <li class="nav-item d-none d-md-block">

            <button type="button" class="nav-link sidebartoggler waves-effect waves-light" :aria-label="$t('header.toggle_sidebar')" data-sidebartype="mini-sidebar">
              <i class="sl-icon-menu font-20"></i>
            </button>

          </li>

        </ul>

        <ul class="navbar-nav float-right">

          <li ref="localeDropdown" class="nav-item dropdown mr-2" :class="{ show: isLocaleMenuOpen }">

            <button type="button" class="nav-link dropdown-toggle text-muted waves-effect waves-dark locale-toggle" :aria-label="$t('header.language_menu')" :aria-expanded="isLocaleMenuOpen ? 'true' : 'false'" @click.stop.prevent="toggleLocaleMenu">
              <span class="flag-icon" :class="currentFlagClass"></span>
              <span class="d-none d-md-inline ml-1">{{ currentLocaleLabel }}</span>
            </button>

            <div class="dropdown-menu dropdown-menu-right" :class="{ show: isLocaleMenuOpen }">

              <button

                v-for="option in localeOptions"

                :key="option.value"

                type="button"

                class="dropdown-item"

                :class="{ active: locale === option.value }"

                @click="changeLocale(option.value)"

              >
                <span class="flag-icon" :class="`flag-icon-${option.flag}`"></span>
                {{ option.label }}
              </button>

            </div>

          </li>

          <li ref="profileDropdown" class="nav-item dropdown" :class="{ show: isProfileMenuOpen }">

            <button type="button" class="nav-link dropdown-toggle text-muted waves-effect waves-dark pro-pic" :aria-label="$t('header.user_menu')" :aria-expanded="isProfileMenuOpen ? 'true' : 'false'" @click.stop.prevent="toggleProfileMenu">
              <span class="topbar-avatar" aria-hidden="true">
                <i class="fas fa-user"></i>
              </span>
            </button>

            <div class="dropdown-menu dropdown-menu-right user-dd topbar-user-menu" :class="{ show: isProfileMenuOpen }">

              <div class="topbar-user-menu__header">

                <p class="topbar-user-menu__email mb-0">{{ userEmail }}</p>

              </div>

              <div class="topbar-user-menu__body">

                <router-link to="/profile" class="dropdown-item" @click.native="isProfileMenuOpen = false">

                  <i class="ti-user"></i><span>{{ $t('header.my_profile') }}</span>

                </router-link>

                <a class="dropdown-item" href="#" @click.prevent="handleLogout">

                  <i class="fa fa-power-off"></i><span>{{ $t('header.logout') }}</span>

                </a>

              </div>

            </div>

          </li>

        </ul>

      </div>

    </nav>

  </header>

</template>



<script>

import { mapActions, mapGetters } from 'vuex'
import { LOCALE_OPTIONS, localeFlagClass } from '@/utils/locale'



export default {

  data() {

    return {

      isProfileMenuOpen: false,

      isLocaleMenuOpen: false,

    }

  },

  computed: {

    ...mapGetters('auth', ['user']),

    ...mapGetters('app', ['locale']),

    userEmail() {

      return this.user?.email || '-'

    },

    localeOptions() {
      return LOCALE_OPTIONS.map((item) => ({
        ...item,
        label: this.$t(item.labelKey),
      }))
    },

    currentLocaleLabel() {
      const item = LOCALE_OPTIONS.find((opt) => opt.value === this.locale)
      return item ? this.$t(item.labelKey) : this.$t('locale.english')
    },

    currentFlagClass() {
      return localeFlagClass(this.locale)
    },

  },

  watch: {

    '$route'() {

      this.isProfileMenuOpen = false

      this.isLocaleMenuOpen = false

    },

  },

  mounted() {

    document.addEventListener('click', this.closeMenusOnClickOutside)

  },

  beforeDestroy() {

    document.removeEventListener('click', this.closeMenusOnClickOutside)

  },

  methods: {

    ...mapActions('auth', ['logout']),

    ...mapActions('app', ['setLocale']),

    toggleProfileMenu() {

      this.isProfileMenuOpen = !this.isProfileMenuOpen

      this.isLocaleMenuOpen = false

    },

    toggleLocaleMenu() {

      this.isLocaleMenuOpen = !this.isLocaleMenuOpen

      this.isProfileMenuOpen = false

    },

    closeMenusOnClickOutside(event) {

      if (this.isProfileMenuOpen && this.$refs.profileDropdown && !this.$refs.profileDropdown.contains(event.target)) {

        this.isProfileMenuOpen = false

      }

      if (this.isLocaleMenuOpen && this.$refs.localeDropdown && !this.$refs.localeDropdown.contains(event.target)) {

        this.isLocaleMenuOpen = false

      }

    },

    changeLocale(locale) {

      this.setLocale({ locale, i18n: this.$i18n })

      this.isLocaleMenuOpen = false

    },

    async handleLogout() {

      await this.logout()

      this.$toast.success(this.$t('header.logout_success'))

      this.$router.push('/login')

    },

  },

}

</script>



<style scoped>

.navbar-dark .navbar-nav .nav-link {

  color: rgba(0, 0, 0, 0.8) !important;

}



.dropdown-item.active {
  background-color: var(--wc-primary);
  color: #fff;
}

.locale-toggle .flag-icon {
  width: 1.5em;
  line-height: 1.1em;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.dropdown-item .flag-icon {
  margin-right: 0.5rem;
}

.pro-pic {
  padding-top: 0.35rem;
  padding-bottom: 0.35rem;
}

.topbar-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  border-radius: 50%;
  background: var(--wc-bg-subtle, #e9ecef);
  color: var(--wc-text, #6c757d);
  font-size: 0.8rem;
  border: 1px solid var(--wc-border, #dee2e6);
}

</style>


